import { BaseModel } from '../base.model'
import { User } from '../user.model'
import { OnlineInterviewerShedulePeriod } from './online-interviewer-schedule-period.model'

const hour = 60 * 60 // час в секундах

export class OnlineInterviewerShedule extends BaseModel<OnlineInterviewerShedule> {
  static DEFAULT_ATTRIBUTES = {
    utcOffset: 0,
    periods: [],
    state: "active"
  }
  
  utcOffset: number
  interviewer: User
  interviewerId: number
  periods: OnlineInterviewerShedulePeriod[]
  state: string

  get notRemovedPeriods(): OnlineInterviewerShedulePeriod[] {
    return this.periods.filter(p => !p.isRemoved)
  }

  get utcOffsetInHours(): number {
    return this.utcOffset / hour
  }

  set utcOffsetInHours(hours: number) {
    this.utcOffset = hours * hour
  }

  get isRemoved(): boolean {
    return this.state == 'removed'
  }

  get isDisabled(): boolean {
    return this.state == 'disabled'
  }

  get isActive(): boolean {
    return this.state == 'active'
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/online-interviewer-schedule/online-interviewer-schedule.model.ts